import {
  combineReducers,
  configureStore,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { Action } from "@reduxjs/toolkit";
import { gatedContentSlice, ungatedContentSlice, userSlice } from "./reducers";
import storageEngine from "./storageEngine";
// import { routes } from "@/utilities";

const RESET_STATE = "RESET_STATE";
const CACHE_VERSION = Number(process.env.NEXT_PUBLIC_CACHE_VERSION) || 1;

export const resetState = (): Action => ({ type: RESET_STATE });
const rootReducer = (state: any, action: PayloadAction) => {
  if (action.type === RESET_STATE) {
    state = undefined;
    window.location.href = `/`;
  }
  return combineReducers({
    userStateReducer: userSlice.reducer,
    gatedContentStateReducer: gatedContentSlice.reducer,
    unGatedContentStateReducer: ungatedContentSlice.reducer,
  })(state, action);
};

const persistConfig = {
  key: "root",
  storage: storageEngine,
  version: CACHE_VERSION,
  blacklist: ["unGatedContentStateReducer"],
  migrate: (state: any) => {
    // If stored version doesn't match current version, clear the cache
    if (state && state._persist && state._persist.version !== CACHE_VERSION) {
      console.log(
        `🔄 Redux Persist cache cleared: version mismatch (stored: ${state._persist.version}, current: ${CACHE_VERSION})`
      );
      return Promise.resolve(undefined); // Clear state
    }
    console.log(`✅ Redux Persist cache version: ${CACHE_VERSION}`);
    return Promise.resolve(state);
  },
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
// Infer the type of makeStore
export type AppStore = ReturnType<() => typeof store>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
